var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconaIndietro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.016,
    height: 13.219,
    viewBox: "0 0 11.016 13.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_indietro",
    "data-name": "icona indietro",
    transform: "translate(-7 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow---Left-2",
    transform: "translate(7 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_39",
    "data-name": "Tracciato 39",
    d: "M.407,5.364C.469,5.3.7,5.027.923,4.8A23.893,23.893,0,0,1,7.307.369,5.086,5.086,0,0,1,8.606,0a2.13,2.13,0,0,1,.986.24,2.064,2.064,0,0,1,.876,1,10.841,10.841,0,0,1,.282,1.172A26.415,26.415,0,0,1,11.016,6.6a30.541,30.541,0,0,1-.235,4.064,9.358,9.358,0,0,1-.376,1.462,1.966,1.966,0,0,1-1.737,1.093H8.606a5.374,5.374,0,0,1-1.455-.451A23.894,23.894,0,0,1,.907,8.4a6.235,6.235,0,0,1-.531-.61A1.965,1.965,0,0,1,0,6.617,2.065,2.065,0,0,1,.407,5.364",
    transform: "translate(0)",
    fill: "#1b1b1b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaIndietro);
export default __webpack_public_path__ + "static/media/icona_indietro.84e3468f7ba4d9401e48b57f0041efcf.svg";
export { ForwardRef as ReactComponent };